import { gql } from '@apollo/client';

export const SONGPOP_LEGACY_PACK_DROP_FRAGMENT = gql`
  fragment SongpopLegacyPackDropFragment on SongpopLegacyPackDropConfig {
    id
    name
    status
    startDate
    stopDate
    capEnabled
    capSeats
    seatsSold
    skuId
    priceUsd
    priceUsdBase
    offerPercentage
    instantRewards {
      type
      amount
      itemId
    }
    notifSchedule {
      anchor
      offsetHours
      title
      body
      fireDate
      sent
    }
    created
    updatedAt

    filterUserIds
    filterSubscriptionTier
    filterUserMinCreationDate
    filterUserMaxCreationDate
    filterAppVersion
    filterAppVersionOperator
    filterUserLevel
    filterExcludedUserIds
    filterHadSub
    filterSpendTiers
    chestEnabled
    chestPool {
      itemsPerOpening
      contents {
        weight
        reward {
          type
          itemId
        }
        amountMode
        amount
        minAmount
        maxAmount
      }
    }
  }
`;

export const SONGPOP_LEGACY_PACK_SKU_OPTIONS_FRAGMENT = gql`
  fragment SongpopLegacyPackSkuOptionFragment on SongpopLegacyPackSkuOption {
    id
    cost
    iosSku
    androidSku
    iosPlaceholder
    androidPlaceholder
    retired
  }
`;

export const SONGPOP_LEGACY_PACK_DROPS_QUERY = gql`
  query getSongpopLegacyPackDrops {
    liveOps {
      songpopLegacyPackDrops {
        ...SongpopLegacyPackDropFragment
      }
      songpopLegacyPackSkus {
        ...SongpopLegacyPackSkuOptionFragment
      }
    }
  }
  ${SONGPOP_LEGACY_PACK_DROP_FRAGMENT}
  ${SONGPOP_LEGACY_PACK_SKU_OPTIONS_FRAGMENT}
`;

export const CREATE_SONGPOP_LEGACY_PACK_DROP = gql`
  mutation createSongpopLegacyPackDrop($input: CreateSongpopLegacyPackDropInput!) {
    createSongpopLegacyPackDrop(input: $input) {
      ...SongpopLegacyPackDropFragment
    }
  }
  ${SONGPOP_LEGACY_PACK_DROP_FRAGMENT}
`;

export const UPDATE_SONGPOP_LEGACY_PACK_DROP = gql`
  mutation updateSongpopLegacyPackDrop($input: UpdateSongpopLegacyPackDropInput!) {
    updateSongpopLegacyPackDrop(input: $input) {
      ...SongpopLegacyPackDropFragment
    }
  }
  ${SONGPOP_LEGACY_PACK_DROP_FRAGMENT}
`;

export const DELETE_SONGPOP_LEGACY_PACK_DROP = gql`
  mutation deleteSongpopLegacyPackDrop($id: ID!) {
    deleteSongpopLegacyPackDrop(id: $id)
  }
`;

// Next time-limited event: a DRAFT copy of the latest one.
export const START_NEW_SONGPOP_LEGACY_PACK_EVENT = gql`
  mutation startNewSongpopLegacyPackEvent($name: String!) {
    startNewSongpopLegacyPackEvent(name: $name) {
      ...SongpopLegacyPackDropFragment
    }
  }
  ${SONGPOP_LEGACY_PACK_DROP_FRAGMENT}
`;

export const SONGPOP_LEGACY_PACK_CONFIG_QUERY = gql`
  query getSongpopLegacyPackConfig {
    liveOps {
      songpopLegacyPackConfig {
        availableForKids
        availableForNonKids
        perksEnabled
        perks
        instantRewards {
          type
          amount
          itemId
        }
        chestReset {
          mode
          utcHour
          utcMinute
          cooldownHours
        }
        chestEnabled
        chestPool {
          itemsPerOpening
          contents {
            weight
            reward {
              type
              itemId
            }
            amountMode
            amount
            minAmount
            maxAmount
          }
        }
        foundersWallEnabled
        foundersWallShowKids
      }
      songpopLegacyPackPerkFields {
        key
        kind
        default
        min
        max
        allowUnlimited
      }
    }
  }
`;

export const SONGPOP_LEGACY_PACK_FEATURE_QUERY = gql`
  query getSongpopLegacyPackFeature {
    liveOps {
      songpopLegacyPackConfig {
        enabled
      }
    }
  }
`;

export const UPDATE_SONGPOP_LEGACY_PACK_CONFIG = gql`
  mutation updateSongpopLegacyPackConfig($input: SongpopLegacyPackConfigInput!) {
    updateSongpopLegacyPackConfig(input: $input) {
      enabled
      availableForKids
      availableForNonKids
      perksEnabled
      perks
      chestEnabled
      foundersWallEnabled
      foundersWallShowKids
    }
  }
`;
